import {
  ComponentCmsDataFormQuestion,
  ComponentCmsDataFormQchoice,
  Enum_Componentcmsdataformquestion_Type,
} from "@/generated";
import { useCallback } from "react";

export const useValidateChoice = (
  currentQuestion: ComponentCmsDataFormQuestion,
  otherAnswer: string
) => {
  return useCallback(
    (choice: ComponentCmsDataFormQchoice) => {
      // For numeric types, validate the input
      if (
        currentQuestion.type ===
          Enum_Componentcmsdataformquestion_Type.Number &&
        choice.choice_text
      ) {
        const num = parseFloat(choice.choice_text);
        if (isNaN(num)) return false;
      }

      // For date types, validate the date
      if (
        (currentQuestion.type === Enum_Componentcmsdataformquestion_Type.Date ||
          currentQuestion.type ===
            Enum_Componentcmsdataformquestion_Type.DateAndTime ||
          currentQuestion.type ===
            Enum_Componentcmsdataformquestion_Type.Birthday) &&
        choice.choice_text
      ) {
        const date = new Date(choice.choice_text);
        if (date.toString() === "Invalid Date") return false;
      }

      // For required questions, ensure there's a value
      if (currentQuestion.is_required && !choice.choice_text && !otherAnswer) {
        return false;
      }

      return true;
    },
    [currentQuestion, otherAnswer]
  );
};
